import React from 'react';
import SectionRenderer from 'scheduling/components/WeekView/CellRenderers/SectionRenderer';

const GroupRenderer = ({ value: labelId, isExpended, toggleRow, labels }) => (
  <SectionRenderer
    isGroup
    label={labels[labelId]}
    isExpended={isExpended}
    toggleRow={toggleRow}
    showEditOptions={false}
  />
);

export default React.memo(GroupRenderer);
